module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/institutions/institutions.component.css
// module id = ./src/app/components/institutions/institutions.component.css
// module chunks = main